import React from "react";

// Header genérico
import HeaderPasos from "../../../componentsUI/estructura/headerPasos/headerPasos.js";

// Componentes
import MesasGrid from "../mesas/MesaGrid.js";
import ProductosLayout from "../productos/contenedorPrincipal/ProductosLayout.js";
import OrdenLayout from "../ordenes/layout/OrdenLayout.js";


const pasosVenta = [
  {
    id: "mesa",
    label: "Ver Mesa",
    component: (
      <div className="mesa-section">
        <MesasGrid />
      </div>
    ),
  },
  {
    id: "productos",
    label: "Seleccionar Productos",
    component: (
      <div className="productos-section">
        <ProductosLayout />
      </div>
    ),
  },
  {
    id: "ordenes",
    label: "Ver Ordenes",
    component: (
      <div className="confirmar-pedido-section">
        <OrdenLayout />
      </div>
    ),
  },
];

export default function TemplateVenta() {
  return (
    <HeaderPasos
      titulo="Ventas"
      pasos={pasosVenta}
      pasoInicial="mesa"
    />
  );
}
